import './Services.css'

const Services = () => {
    return (
        <div>
            <div className="services" data-aos="fade-up"
                data-aos-duration="1000">
                <h3>AMENITIES AND SERVICES</h3>
                <div className="services-cards">
                    <div className="services-card">
                        <img src="./SquarePhotos/Services/Gym.png" alt="services" />
                        <p>GYM</p>
                    </div>
                    <div className="services-card">
                        <img src="./SquarePhotos/Services/Coffeeshop.png" alt="services" />
                        <p>COFFEE SHOP</p>
                    </div>
                    <div className="services-card">
                        <img src="./SquarePhotos/Services/EVCharging.png" alt="services" />
                        <p>EV CHARGING</p>
                    </div>
                    <div className="services-card">
                        <img src="./SquarePhotos/Services/Electricty.png" alt="services" />
                        <p>24/7 ELECTRICITY</p>
                    </div>
                    <div className="services-card">
                        <img src="./SquarePhotos/Services/5.png" alt="services" />
                        <p>DANCING FOUNTAIN</p>
                    </div>
                    <div className="services-card">
                        <img src="./SquarePhotos/Services/Elevator.png" alt="services" />
                        <p>SMART ELEVATOR</p>
                    </div>
                    <div className="services-card">
                        <img src="./SquarePhotos/Services/7.png" alt="services" />
                        <p>SMART APPARTMENTS</p>
                    </div>
                    <div className="services-card">
                        <img src="./SquarePhotos/Services/8.png" alt="services" />
                        <p>FULLY SMART BUILDING</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Services